import { ScoreType } from '../../store/admin/eventFormats/store';
import { IAdminTeamResult } from '../../store/admin/teamResults/store';
import { TIFormatPrefix } from '../../store/admin/roundFormats/store';

import { TTeamFormatPrefix } from '../../scenes/admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { capitalizeFirstLetter } from '../utils';
import { toHandicap } from './toHandicap';

export const displayScore = (
  playerResult: IAdminTeamResult,
  selectedTeamFormat?: TTeamFormatPrefix | TIFormatPrefix,
  selectedScoreType?: ScoreType
) => {
  if (!selectedScoreType) {
    return '';
  }

  const scoreType = capitalizeFirstLetter(ScoreType[selectedScoreType].toLowerCase());

  const scoreField = `${selectedTeamFormat}${scoreType}AuxScore`;

  const score = toHandicap(playerResult[scoreField as keyof IAdminTeamResult] as number);

  return score.includes('+')
    ? score.replace('+', '-')
    : Number(score) === 0
    ? 'E'
    : Number(score) > 0
    ? `+${score}`
    : score;
};
